import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    Box,
    Container,
    Divider,
    Typography,
    useMediaQuery,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { darkGreen, lightGreen, theme } from "../Resources/Design/theme";
import CookieBar from "./CookieBar";
import { Motion } from "./Motion";
import logo from '../Pages/Main/logo.png';
import { fullCenter, textColor, textStyle } from "../Pages/Main/constants";

const color = textColor;

const Lock = () => {
    const editedIcon = React.cloneElement(<LockIcon />, {
        style: {
            height: "12px",
            maxWidth: "12px",
            fill: textColor,
        },
    });
    return <>{editedIcon}</>;
};

function BaseFooter({ extended = true }) {
    const [cookieOpen, setCookieOpen] = useState(false);
    const mobile = useMediaQuery(theme.breakpoints.only("xs"));
    const tablet = useMediaQuery(theme.breakpoints.down("md"));
    let navigate = useNavigate();

    const FOOTER_HEIGHT = mobile ? 170 : 180;

    return (
        <footer>
            {<CookieBar open={cookieOpen} setOpen={setCookieOpen} />}
            <Box
                sx={{
                    width: "100%",
                    minHeight: `${FOOTER_HEIGHT}px`,
                    bgcolor: "rgba(255, 173, 102, 0.7)",
                    position: "static",
                    bottom: 0,
                    boxShadow: "0px -2px 5px 0px rgba(115,117,122,0.2)",
                    overflow: 'hidden',
                }}
            >
                <Container maxWidth="lg" sx={{}}>
                    <Box
                        sx={{
                            width: "100%",
                            height: "100%",
                            px: "20px",
                            pt: '20px',
                            display: "flex",
                            alignItems: "flex-start",
                            alignContent: 'flex-start',
                            justifyContent: 'flex-start',
                            flexDirection: 'row',
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: 'center',
                                alignItems: 'center',
                                alignContent: 'center'
                            }}
                        >
                            <Box
                                sx={{
                                    marginRight: "auto",
                                    display: "flex",
                                    justifyContent: "center",
                                    textDecoration: "none",
                                    pl: "0px",
                                    width: '100%',
                                }}

                            >
                                <Motion scale={1.03}>
                                    <Box
                                        component={Link}
                                        sx={{
                                            marginRight: "auto",
                                            display: "flex",
                                            alignItems: "center",
                                            alignContent: "center",
                                            justifyContent: "center",
                                            textDecoration: "none",
                                            pl: "0px",
                                            "&:hover": {
                                                cursor: "pointer",
                                            },
                                        }}
                                        to={"/"}
                                    >
                                        <Box component={'img'} alt='logo hello kids camp' src={logo} sx={{
                                            width: mobile ? '80px' : '100px',
                                            transition: "width .3s ease-in-out",
                                            py: '0px', filter: `drop-shadow(0px 0px 1px rgba(0,0,0,0.3))`,
                                        }} />
                                    </Box>
                                </Motion>

                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', mt: '8px' }}>
                                <Motion scale={1.03}>
                                    <Box
                                        sx={{
                                            minWidth: { xs: 'auto', sm: '132px' },
                                            width: "fit-content",
                                            height: "22px",
                                            bgcolor: '#fafafa',
                                            display: "flex",
                                            flexDirection: "row",
                                            alignContent: "center",
                                            alignItems: "center",
                                            justifyContent: 'flex-start',
                                            borderRadius: "12px",
                                            cursor: "pointer",
                                        }}

                                    >
                                        <Link to="/cookies" target="_blank" style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignContent: "center",
                                            alignItems: "center",
                                            height: '100%',
                                            width: 'fit-content',
                                            padding: "4px",
                                            pl: { xs: '0px', sm: '8px', },
                                            textDecoration: 'none'
                                        }}>
                                            <Lock />
                                            {!mobile && (
                                                <Typography
                                                    sx={{ mx: "15px", fontSize: "11px", mt: "1px", color: textColor, fontWeight: 'bold' }}
                                                >
                                                    Cookies policy
                                                </Typography>
                                            )}
                                        </Link>
                                    </Box>
                                </Motion>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: "100%",
                                height: '100%',
                                minHeight: '120px',
                                ml: mobile ? '20px' : '32px',
                            }}
                        >

                            {mobile ?
                                <Typography sx={{
                                    ...textStyle,
                                    fontSize: "14px",
                                    lineHeight: "18px",
                                    textAlign: "center",
                                    color: color,
                                    width: "100%",
                                    mt: '16px',
                                    fontWeight: 500,
                                }}>
                                    <span>© {new Date().getFullYear()} Hello Kids Camp<br />

                                    </span><a style={{ color: color, textDecoration: 'none' }} href="tel:777120048">Tel.: 777 120 048</a> <br /> <br />

                                    <Link style={{ color: color, textDecoration: 'none' }} to="/dokumenty" target="_blank">Dokumenty</Link>
                                </Typography> :
                                <Typography
                                    sx={{
                                        ...textStyle,
                                        fontSize: "14px",
                                        lineHeight: "24px",
                                        textAlign: "center",
                                        color: color,
                                        width: "100%",
                                        mt: '24px',
                                        fontWeight: 500,
                                        maxWidth: '595px'
                                    }}
                                >
                                    <span>© {new Date().getFullYear()} Hello Kids Camp | <a style={{ color: color, textDecoration: 'none' }} href="mailto:petra.kalasova@hellokidscamp.cz">petra.kalasova@hellokidscamp.cz</a> | </span>
                                    <a style={{ textDecoration: 'none', color: color }} href="tel:777120048">Tel.: 777 120 048</a><span>&#32;</span>
                                    <Link style={{ color: color, textDecoration: 'none' }} to="/dokumenty" target="_blank">Dokumenty</Link>
                                </Typography>}


                        </Box>
                    </Box>
                </Container>
            </Box>
        </footer>
    );
}

export default BaseFooter;
